import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDeRecusarTermos',
  props: {
    onConfirmar: null,
    onCancelar: null
  },
  setup(__props: any) {

const props = __props as {
    onConfirmar?: () => unknown,
    onCancelar?: () => unknown,
};



const termoRecusado = ref(false)
const mostra = ref(false)

watch(mostra, () => {
    if (mostra) termoRecusado.value = false
})

const confirmar = () => {
    mostra.value = false
    props.onConfirmar?.()
}

const cancelar = () => {
    mostra.value = false
    props.onCancelar?.()
}

return { __sfc: true,props, termoRecusado, mostra, confirmar, cancelar }
}

})